import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import CustomStore from 'devextreme/data/custom_store';
import { ToastService } from 'ng-uikit-pro-standard';
import { EmployeesService } from 'src/app/services/employees.service';
import { OpenRifService } from 'src/app/services/open-rif.service';
import { TaskService } from 'src/app/services/task.service';
import { AppConfigService } from 'src/app/app-config.service.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-new-rfi',
  templateUrl: './new-rfi.component.html',
  styleUrls: ['./new-rfi.component.scss']
})
export class NewRfiComponent implements OnInit {
  // @Input() projectInfo: any;
  @Input() projectid: any;
  private _projectInfo: any;
  plusContactButton: { icon: string; type: string; hint: string; onClick: () => void; };

  @Input('projectInfo')
  set projectInfo(projectInfo: any) {
    this._projectInfo = projectInfo;

    if (this.newRFI && projectInfo) {
      this.newRFI.get('Project').setValue(projectInfo.ID + '-'+projectInfo.NAME);
      this.hasproject = true;
    }
    // if (projectInfo && projectInfo.projectInfoid > 0)
    // this.setprojectInfoInfo(projectInfo);
  }

  get projectInfo(): any { return this._projectInfo; }


  @Input() popupnewRFI:boolean;
  @Output() onmodalhidden = new EventEmitter<any>();
  @Output() onsubmit = new EventEmitter<any>();

  newRFI: FormGroup;
  sentTo: any;
  idSentTo: any;
  millisecondsInDay = 24 * 60 * 60 * 1000;
  today= new Date().getTime();
  dataRfi: Array<any>;
  createdBy: any;
  priority: Array<any> = [{id: 1 , name:'High'},  {id: 2, name: 'Normal'}, {id: 3, name:'Low'} ];
  rfiDate = {todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: this.today};
  respondedByDate = {todayButton: {}, prevDateButton: {}, nextDateButton: {}, showDate: this.today};
  employees = [];
  projectslist: any;

  hasproject = false;

  popupExpandDescrip: boolean;
  popupExpandRes: boolean;

  cancelExpandDescripButton: any;
  saveExpandDescripButton: any;
  cancelExpandResButton: any;
  saveExpandResButton: any;
  
  RFIDescription: any;
  RFIResponse: any;

  cancelButton: any;
  saveButton: any;
  settings: any = {};

  itemsEditorTurnOverSheet: any = [

    "undo", "redo", "separator",

    {
      name: "size",
      acceptedValues: ["8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt"]
    },
    {
      name: "font",
      acceptedValues: ["Arial", "Courier New", "Georgia", "Impact", "Lucida Console", "Tahoma", "Times New Roman", "Verdana"]
    },

    "separator", "bold", "italic", "strike", "underline", "separator",
    "alignLeft", "alignCenter", "alignRight", "alignJustify", "increaseIndent",
    "decreaseIndent", "separator",
    "orderedList", "bulletList", "separator",

    {
      name: "header",
      acceptedValues: [false, 1, 2, 3, 4, 5]
    },

    "color","background","link", "clear","codeBlock","blockquote", "separator", "insertTable","deleteTable",
    "insertRowAbove","insertRowBelow","deleteRow","insertColumnLeft","insertColumnRight",
    "deleteColumn","cellProperties","tableProperties",
  ];

  popupNewContact:boolean = false
  
  constructor(
    private employeeService: EmployeesService,
    private openRif: OpenRifService,
    private toast: ToastService,
    private taskService: TaskService,
    private appconfig: AppConfigService,
    private translate:TranslateService

  ) {
    
    this.initRFI();
    this.settings.dateFormat = this.appconfig.dateFormat;

    this.plusContactButton = {
      icon:"plus",
      type: "button",
      hint:"New Contact",
      onClick: () => {
        this.popupNewContact = true;
      }
    };
    
   }

  ngOnInit() {

    this.cancelButton = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupnewRFI = false;
        this.onHidden();
      },
    };

    this.cancelExpandDescripButton = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.popupExpandDescrip = false;
        this.closeExpandDescrip()
      },
    };

    this.cancelExpandResButton = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        // this.popupExpandRes = false;
        this.closeExpandRes()
      },
    };

    this.saveButton = {
      text: this.translate.instant('btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        // this.type = 1;
        this.saveRFI();
      },
    };

    this.saveExpandDescripButton = {
      text: this.translate.instant('btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        this.newRFI.get('Description').setValue(this.RFIDescription)
        this.closeExpandDescrip()
      },
    };

    this.saveExpandResButton = {
      text: this.translate.instant('btnSave'),
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        this.newRFI.get('Response').setValue(this.RFIResponse)
        this.closeExpandRes()
      },
    };


    let mythis = this;
    this.projectslist = new CustomStore({
      key: "ID",
      load: function (loadOptions: any) {
        return mythis.taskService.GetProjectByName(loadOptions.searchValue)
          .toPromise()
          .then((data: any) => {
            return data;
          })
          .catch(error => { throw 'Data Loading Error' });
      }
    });

    // this.popupnewRFI = true;
  }

  inputsDate(date){
    date.todayButton = {
      text: this.translate.instant('btnToday'),
      elementAttr: {
        id: 'today-Btn'
      },
      onClick: () => {
        date.showDate = new Date().getTime();
      }
    };

    date.prevDateButton = {
      icon: "spinprev",
      stylingMode: "text",
      onClick: () => {
        date.showDate -= this.millisecondsInDay;
      }
    };

    date.nextDateButton = {
      icon: "spinnext",
      stylingMode: "text",
      onClick: () => {
        date.showDate += this.millisecondsInDay;
      }
    };
  }

  updateProjectInfo(ev) {
    console.log(ev);
    if(ev.selectedItem)
      this.projectid = ev.selectedItem.ID;
    else
    this.projectid = 0;
  }

  onHidden() {
    this.popupnewRFI = false;
    this.onmodalhidden.emit();
    this.initRFI();
  }

  getEmployees(){
    this.employeeService.GetAll().subscribe(result=>{
      this.employees = result.map((val)=>{
        return {
          id: val.ID,
          name: val.FULLNAME
        }
      });
    })
  }

  getContacts(){
    this.openRif.GetContacts2().subscribe(result=>{
      this.sentTo = result.map(x=>{
        x.First += " " + "(" + x["Email Address"] + ")"
        return x;
      });
    })
  }

  searchContact(nameContact){
    let found = this.sentTo.find(data=> data.First == nameContact);
    if(found!==undefined){ this.idSentTo = found.ID; }

  }

  initRFI(){
    let projectname = this.projectInfo ? this.projectInfo.ID + '-' + this.projectInfo.NAME : '';
    console.log(projectname);
    this.newRFI = new FormGroup ({
      Name: new FormControl('', [Validators.required]),
      Project: new FormControl(projectname, []),
      Number: new FormControl('', []),
      Date: new FormControl(new Date(), []),
      CreatedBy: new FormControl('', []),
      Priority: new FormControl('', [Validators.required]),
      Attachment: new FormControl('', []),
      SentTo: new FormControl('', [Validators.required]),
      RespondedBy: new FormControl(new Date(), []),
      Responded: new FormControl('', []),
      Description: new FormControl('', []),
      Response: new FormControl('', []),
    })
    this.inputsDate(this.rfiDate);
    this.inputsDate(this.respondedByDate);
    this.respondedByDate.showDate = new Date().getTime();
    this.getEmployees();
    this.getContacts();
  }
  

  saveRFI(){
    console.log(this.newRFI.value);
    let form = this.newRFI.value;
    let needresponse;
    form.Responded == true ? needresponse = 1 : needresponse = 0;


    if(!this.projectid) {
      this.toast.success(this.translate.instant('msgProjName'));
      return;
    }
    if(!form.Name) {
      this.toast.warning(this.translate.instant('msgRFI'));
      return;
    }
    if(!form.Priority) {
      this.toast.warning(this.translate.instant('msgPrio'));
      return;
    }
    if(!form.SentTo) {
      this.toast.warning(this.translate.instant('msgCont'));
      return;
    }

    if(!this.projectid) {
      this.toast.warning(this.translate.instant('msgProjName'));
      return;
    }
    form.Date = new Date(form.Date);
    console.log(form.Date);
    form.RespondedBy = new Date(form.RespondedBy);
    console.log("🚀 ~ NewRfiComponent ~ saveRFI ~ form:", form)

    this.openRif.InsertRfi(form.Name,
      form.Number,
      this.projectid,
      form.Date,
      this.idSentTo,
      form.Priority,
      form.CreatedBy,
      form.RespondedBy,
      needresponse,
      form.Response,
      form.Description,
      0 )
    .subscribe(result=>{
      console.log(result);
      this.popupnewRFI = false;
      // this.datagrid.reloadComponent();
      // this.getAllRFI();
      this.toast.success(this.translate.instant('msgRFIDetInfoSavSucc'));
      this.newRFI.reset();
      this.initRFI();
      this.onsubmit.emit();
    })
  }

  ExpandRFIDescrip(){
    let data = this.newRFI.value;
    this.RFIDescription = data.Description
    this.popupExpandDescrip = true

  }

  ExpandRFIRes(){
    let data = this.newRFI.value;
    this.RFIResponse = data.Response
    this.popupExpandRes = true
  }

  closeExpandDescrip(){
    this.popupExpandDescrip = false
    this.RFIDescription = undefined
  }

  closeExpandRes(){
    this.popupExpandRes = false
    this.RFIResponse = undefined
  }

  onsave(data){
    console.log(data)

    this.getContacts()

    this.idSentTo = data.id


    this.newRFI.get("SentTo").setValue(data.First + " " + data.Last +" " + "(" + data.Email + ")")
    



  }

}
